/**
 * Main-thread metrics wrapper (logger). Service worker imports swAuthSyncMetricsCore only.
 */
import createLogger from './logger'
import {
  recordSwAuthSyncPosted as recordSwAuthSyncPostedCore,
  getSwAuthSyncMetrics,
  recordSwAuthIdbReadFailed,
  recordSwAuthReloadMismatchExhausted,
  recordSwAuthReloadMismatchRetry,
  recordSwAuthReloadOk,
  recordSwAuthReloadWithoutEpoch,
  resetSwAuthSyncMetrics,
  type SwAuthReloadMismatchKind,
  type SwAuthSyncMetricSnapshot,
} from './swAuthSyncMetricsCore'

export type { SwAuthReloadMismatchKind, SwAuthSyncMetricSnapshot }
export {
  getSwAuthSyncMetrics,
  recordSwAuthIdbReadFailed,
  recordSwAuthReloadMismatchExhausted,
  recordSwAuthReloadMismatchRetry,
  recordSwAuthReloadOk,
  recordSwAuthReloadWithoutEpoch,
  resetSwAuthSyncMetrics,
}

const logger = createLogger('utils/swAuthSyncMetrics')

export function recordSwAuthSyncPosted(preflight: {
  matched: boolean
  waitMs: number
  hasEpoch: boolean
  preflightReadFailed?: boolean
}): void {
  if (preflight.preflightReadFailed && preflight.hasEpoch) {
    logger.warn('SW auth sync main IDB preflight read failed; posting message anyway', {
      waitMs: preflight.waitMs,
    })
  } else if (!preflight.matched && preflight.hasEpoch) {
    logger.warn('SW auth sync IDB preflight timed out; posting message anyway', {
      waitMs: preflight.waitMs,
    })
  }
  recordSwAuthSyncPostedCore(preflight)
}
